import readNumberEnv from './readNumberEnv';

const readRequiredNumberEnv = (envValue: string | undefined, envKey: string): number => {
  const value: number | null = readNumberEnv(envValue);
  if (value === null) {
    throw new Error(
      `The environment variable "${envKey}" must be configured and be a valid number`
    );
  }
  return value;
};

export default readRequiredNumberEnv;
